import ListServices from "@/modules/Profile/components/ListServices/ListServices.vue";
import {
  NAME_FINDERS,
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS,
  GENERAL_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import store from "@/store";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import { mapGetters } from "vuex";
import {
  CLASSES,
  CONTEXT_PANEL_OPTIONS,
  DEFAULT_ICONS,
  EXTRA_ICONS,
  LABELS,
  ARROW_LABEL,
  GO_TO_TOP,
  LIST_CARD_ID
} from "../../constants/HomeConstants";
import ListEvents from "@/modules/Events/components/ListEvents/ListEvents.vue";
import Tasks from "@/modules/Profile/components/Tasks/Tasks.vue";
import ListDocuments from "@/modules/Document/components/ListDocuments/ListDocuments.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ListItem from "@/shared/components/ListItem/ListItem.vue";
import ScrollBottom from "@/shared/components/ScrollBottom/ScrollBottom.vue";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { SearchContext } from "@/shared/models/SearchContext";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import Options from "./components/Options/Options.vue";
import { PanelOptions } from "@/shared/models/PanelOptions";
import GenericSearchBar from "@/shared/components/GenericSearchBar/GenericSearchBar.vue";
import { CONTEXTUAL_ELEMENTS, DATA_DEFAULT } from "./constants/ContextPanel";
import { HeaderInfoGroup } from "@/modules/InfoGroup/models/HeaderInfoGroup";
import { QuerySend } from "@/shared/models/FormQuerySend";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { ModalFormData } from "./models/ModalFormData";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import lodash from "lodash";
import ChatBot from "@/shared/components/ChatBot/ChatBot.vue";
import Chat from "@/shared/components/Chat/Chat.vue";
import ListNotification from "@/modules/Profile/components/ListNotification/ListNotification.vue";

@Component({
  name: "ContextPanel",
  components: {
    ListNotification,
    ListServices,
    Tasks,
    ListEvents,
    ListDocuments,
    EmptyState,
    ListItem,
    ScrollBottom,
    Options,
    GenericSearchBar,
    ModalTemplate,
    Chat,
    ChatBot
  },
  computed: {
    ...mapGetters({
      dataToLateralMenu: "getDataToLateralMenu",
      panelView: "getPanelView"
    })
  }
})
export default class ContextPanel extends Vue {
  dataToLateralMenu!: MenuDataStructure;
  panelView!: boolean;

  active = "";
  panel = CLASSES.PANEL.DESKTOP_INACTIVE;
  inner = CLASSES.CONTENT.DESKTOP_INACTIVE;
  overlay = CLASSES.OVERLAY.ACTIVE;
  isActive = true;
  activeTabClass = this.panelView
    ? CLASSES.ITEM.ACTIVE
    : CLASSES.ITEM.ACTIVE_ALT;
  activeTabName = "timeline";
  activeTabIndex = 0;
  TIMELINE = LABELS.TIMELINE;
  MESSAGES = LABELS.MESSAGES;
  TASK = LABELS.TASK;
  INFORMATION = LABELS.INFORMATION;
  icons = DEFAULT_ICONS;

  userId = "";
  serviceId = "";
  showNewEventAlert = false;
  showServices = false;
  showNotifications = false;
  refreshServices = false;
  assignedTask = false;
  mainTask = "";

  CONTEXT_PANEL_OPTIONS = CONTEXT_PANEL_OPTIONS;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  CONTEXTUAL_ELEMENTS = CONTEXTUAL_ELEMENTS;
  GO_TO_TOP_BTN = GO_TO_TOP;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  loadingData = false;
  showCardsContainer = false;
  showContextualSearch = false;
  contextualElement = "";
  tittleSearch = "";
  CLICK_ACTION = "";
  OPERATIONS: string[] = [];
  filterArray: Filter[] = [];

  itemList: Array<FormStatus | HeaderInfoGroup> = [];
  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleOperation: Function = () => {};
  callbackHandleOperationTemp?: Function;

  admin = false;
  selectedItem = "";
  cardClass = STYLE_CLASSES.CARD;
  SEARCH_LISTS = FORM_CONSTANTS.MENU_BAR.OPTIONS.ADD_LIST;
  options: PanelOptions[] = [];
  showOptions = false;
  descriptions: string[] = [];
  listOptionsToFilter = [];
  views: string[] = [];

  SEARCH_CONTEXT_PANEL_KEY = NAME_FINDERS.CONTEXT_PANEL;
  actionData = DATA_DEFAULT.ACTION_DATA;
  modal = DATA_DEFAULT.MODAL;
  componentName = "";
  textButtonCreate = "";
  showButtonCreate = false;
  arrowLabel = ARROW_LABEL.CLOSE;
  windowHeight = 700;
  showGoTopBtn = false;
  LIST_ID = LIST_CARD_ID;

  mounted() {
    this.views = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE.VIEWS) ?? "[]"
    ) as string[];
    this.panel = this.isMobile
      ? CLASSES.PANEL.MOBILE_ACTIVE
      : CLASSES.PANEL.DESKTOP_ACTIVE;
    this.inner = this.isMobile
      ? CLASSES.CONTENT.MOBILE_ACTIVE
      : CLASSES.CONTENT.DESKTOP_ACTIVE;
    if (this.$route.name === PANEL_INFO_CONSTANTS.FROM.PROFILE) {
      this.assignedTask = false;
      this.userId = this.$route.params.id;
    } else if (this.$route.name === PANEL_INFO_CONSTANTS.FROM.DOCTOR_PROFILE) {
      this.assignedTask = true;
      this.userId = this.$route.params.id;
    } else {
      this.assignedTask = true;
      this.userId = localStorage.getItem(LOCAL_STORAGE.UID) || "";
    }
    this.addSearch();
    this.sendPropertyToParent();

    if (this.isMobile) {
      this.collapsePanel();
    }
  }

  @Watch("showContextualSearch")
  addSearch() {
    for (let index = 0; index < this.icons.length; index++) {
      this.icons[index].class = CLASSES.ITEM.INACTIVE;
    }
    const index = this.icons.findIndex(i => i.key === EXTRA_ICONS.SEARCH.key);
    if (this.showContextualSearch && index === -1) {
      this.icons.unshift({ ...EXTRA_ICONS.SEARCH });
      this.activeTabName = EXTRA_ICONS.SEARCH.key;
      this.activeTabIndex = 0;
    } else if (!this.showContextualSearch && index !== -1) {
      this.icons.splice(index, 1);
      if (this.activeTabName == EXTRA_ICONS.SEARCH.key) {
        this.closePanelLateral();
      }
    }
    this.icons[0].class = CLASSES.ITEM.ACTIVE_ALT;
  }

  addOptions() {
    const index = this.icons.findIndex(i => i.key === "options");
    if (this.showOptions && index === -1) {
      const indexContext =
        this.icons.findIndex(i => i.key === EXTRA_ICONS.SEARCH.key) + 1;
      this.icons.splice(indexContext, 0, { ...EXTRA_ICONS.OPTIONS });
    } else if (!this.showOptions && index !== -1) {
      this.icons.splice(index, 1);
      if (this.activeTabName == "options") {
        this.closePanelLateral();
      }
    }
  }

  validateNewEvent() {
    if (
      this.activeTabName != this.CONTEXT_PANEL_OPTIONS.TIMELINE ||
      !this.isActive
    ) {
      this.showNewEventAlert = true;
    }
  }

  closePanelLateral() {
    if (this.isActive) {
      this.collapsePanel();
    }
  }

  sendToMainView(data: MenuDataStructure) {
    store.commit(STORE_CONSTANTS.TO_MAIN_VIEW, data);
  }

  setActive(index: number) {
    this.icons.forEach((icon, i) => {
      icon.class =
        index === i
          ? !this.panelView
            ? CLASSES.ITEM.ACTIVE_ALT
            : CLASSES.ITEM.ACTIVE
          : CLASSES.ITEM.INACTIVE;
    });
    this.activeTabName = this.icons[index].key;
    this.activeTabIndex = index;
    if (!this.isActive) this.collapsePanel();
    if (index == 0) this.showNewEventAlert = false;
    if (this.activeTabName === CONTEXT_PANEL_OPTIONS.TASK) {
      store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
        from: PANEL_INFO_CONSTANTS.FROM.PANEL,
        type: PANEL_INFO_CONSTANTS.TYPE.TASK,
        action: PANEL_INFO_CONSTANTS.ACTION.REFRESH,
        data: {}
      });
    }
  }

  collapsePanel() {
    if (!this.isActive) {
      this.panel = this.isMobile
        ? CLASSES.PANEL.MOBILE_ACTIVE
        : CLASSES.PANEL.DESKTOP_ACTIVE;
      this.inner = this.isMobile
        ? CLASSES.CONTENT.MOBILE_ACTIVE
        : CLASSES.CONTENT.DESKTOP_ACTIVE;
      this.isActive = true;
      this.overlay = this.isMobile
        ? CLASSES.OVERLAY.ACTIVE
        : CLASSES.OVERLAY.INACTIVE;
      this.setActive(this.activeTabIndex);
    } else {
      this.panel = this.isMobile
        ? CLASSES.PANEL.MOBILE_INACTIVE
        : CLASSES.PANEL.DESKTOP_INACTIVE;
      this.inner = this.isMobile
        ? CLASSES.CONTENT.MOBILE_INACTIVE
        : CLASSES.CONTENT.DESKTOP_INACTIVE;
      this.isActive = false;
      this.overlay = CLASSES.OVERLAY.ACTIVE;
      this.icons.forEach(icon => {
        icon.class = CLASSES.ITEM.INACTIVE;
      });
    }
  }

  @Watch("isActive")
  sendPropertyToParent() {
    this.$emit("isActiveContextPanel", this.isActive);
    this.arrowLabel = this.isActive ? ARROW_LABEL.CLOSE : ARROW_LABEL.OPEN;
    if (
      this.activeTabName == this.CONTEXT_PANEL_OPTIONS.TIMELINE ||
      this.isActive
    ) {
      store.commit(
        STORE_CONSTANTS.TO_CALL_ORIGIN,
        GENERAL_CONSTANTS.CALL_ORIGIN
      );
    }
  }

  @Watch("$vuetify.breakpoint.name")
  handleBreakpoint() {
    this.isActive = true;
    this.collapsePanel();
    this.panel = this.isMobile
      ? CLASSES.PANEL.MOBILE_INACTIVE
      : CLASSES.PANEL.DESKTOP_INACTIVE;
    this.inner = this.isMobile
      ? CLASSES.CONTENT.MOBILE_INACTIVE
      : CLASSES.CONTENT.DESKTOP_INACTIVE;
  }

  get isMobile() {
    return (
      this.$vuetify.breakpoint.name === "sm" ||
      this.$vuetify.breakpoint.name === "xs"
    );
  }

  @Watch("panelView")
  panelViewHandler() {
    this.isActive = true;
    this.collapsePanel();
    this.activeTabClass = this.panelView
      ? CLASSES.ITEM.ACTIVE
      : CLASSES.ITEM.ACTIVE_ALT;
  }

  @Watch("dataToLateralMenu")
  dataToLateralMenuHandler() {
    const validations: { [key: string]: void } = {
      Profile: this.profileValidation(),
      Crud: this.crudValidation()
    };

    validations[this.dataToLateralMenu.from];
  }

  profileValidation() {
    if (
      this.dataToLateralMenu.from === PANEL_INFO_CONSTANTS.FROM.PROFILE &&
      this.dataToLateralMenu.type === PANEL_INFO_CONSTANTS.TYPE.SERVICE
    ) {
      if (
        this.dataToLateralMenu.action === PANEL_INFO_CONSTANTS.ACTION.SHOW &&
        this.dataToLateralMenu.id
      ) {
        this.showServices = true;
        this.showNotifications = true;
        this.setNotification();
        this.serviceId = this.dataToLateralMenu.data.id;
        this.userId = this.dataToLateralMenu.id;
        this.setServices();
        this.refreshServices = !this.refreshServices;
      }

      if (
        this.dataToLateralMenu.action === PANEL_INFO_CONSTANTS.ACTION.REFRESH
      ) {
        if (this.dataToLateralMenu.data?.restart == true) {
          this.serviceId = "";
        }
        this.refreshServices = !this.refreshServices;
      }

      if (this.dataToLateralMenu.action === PANEL_INFO_CONSTANTS.ACTION.HIDE) {
        this.removeServiceIcon();
      }
    }
    if (
      this.dataToLateralMenu.from === PANEL_INFO_CONSTANTS.FROM.PROFILE &&
      this.dataToLateralMenu.type === PANEL_INFO_CONSTANTS.TYPE.TASK
    ) {
      if (
        this.dataToLateralMenu.action === PANEL_INFO_CONSTANTS.ACTION.SHOW &&
        this.dataToLateralMenu.id
      ) {
        this.mainTask = this.dataToLateralMenu.data.id;
        this.userId = this.dataToLateralMenu.id;
        this.setActive(1);
      }
      if (this.dataToLateralMenu.action === PANEL_INFO_CONSTANTS.ACTION.HIDE) {
        this.mainTask = "";
      }
    }
  }
  // set Notification Icon
  setNotification() {
    if (!this.icons.find(icon => icon.key == EXTRA_ICONS.NOTIFICATION.key)) {
      this.icons = this.icons.concat(EXTRA_ICONS.NOTIFICATION);
    }
    if (this.serviceId && this.serviceId != "") {
      const indexService = this.icons.findIndex(
        i => i.key === EXTRA_ICONS.NOTIFICATION.key
      );
      this.setActive(indexService);
    } else {
      this.setActive(0);
    }
  }

  removeNotificationIcon() {
    const indexService = this.icons.findIndex(
      i => i.key === EXTRA_ICONS.NOTIFICATION.key
    );
    if (indexService != -1) {
      this.icons.splice(indexService, 1);
      this.setActive(0);
      this.collapsePanel();
    }
  }

  setServices() {
    if (!this.icons.find(icon => icon.key == EXTRA_ICONS.SERVICES.key)) {
      this.icons = this.icons.concat(EXTRA_ICONS.SERVICES);
    }
    if (this.serviceId && this.serviceId != "") {
      const indexService = this.icons.findIndex(
        i => i.key === EXTRA_ICONS.SERVICES.key
      );
      this.setActive(indexService);
    } else {
      this.setActive(0);
    }
  }

  removeServiceIcon() {
    const indexService = this.icons.findIndex(
      i => i.key === EXTRA_ICONS.SERVICES.key
    );
    if (indexService != -1) {
      this.icons.splice(indexService, 1);
      this.setActive(0);
      this.collapsePanel();
    }
  }

  @Watch("$route")
  setDefaultPanel(to: Route, from: Route) {
    this.icons = DEFAULT_ICONS;
    this.showServices = false;

    if (from.name === PANEL_INFO_CONSTANTS.FROM.PROFILE) {
      this.setActive(0);
      this.collapsePanel();
    }

    if (to.name === PANEL_INFO_CONSTANTS.FROM.PROFILE) {
      this.assignedTask = false;
      this.userId = to.params.id;
    } else if (to.name === PANEL_INFO_CONSTANTS.FROM.DOCTOR_PROFILE) {
      this.assignedTask = true;
      this.userId = to.params.id;
    } else {
      this.assignedTask = true;
      this.userId = localStorage.getItem(LOCAL_STORAGE.UID) || "";
    }
  }

  crudValidation() {
    if (this.dataToLateralMenu.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      switch (this.dataToLateralMenu.action) {
        case PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT:
          this.setSearchContext(this.dataToLateralMenu.data);
          break;

        case PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT:
          this.setListItemContext(this.dataToLateralMenu.data);
          this.showCardsContainer = !!this.dataToLateralMenu.data;
          this.loadingData = false;
          this.showOptions = !!this.selectedItem;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT:
          this.loadingData = true;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS:
          this.loadingData = true;
          this.showCardsContainer = false;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT:
          this.loadingData = false;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CARD_CONTAINER:
          this.showCardsContainer = true;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.HIDE_CARD_CONTAINER:
          this.showCardsContainer = false;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM:
          this.selectedItem = this.dataToLateralMenu.data;
          this.showButtonCreate = !this.selectedItem;
          if (this.options.length >= 1) {
            this.showOptions = !!this.selectedItem;
          }
          break;

        case PANEL_INFO_CONSTANTS.ACTION.UNDO_SELECTED_ITEM:
          this.selectedItem = "";
          if (this.options.length >= 1) {
            this.showOptions = this.dataToLateralMenu.data.showOptions;
          }
          break;

        case PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL:
          this.selectedItem = "";
          this.showButtonCreate = false;
          if (this.options.length >= 1) {
            this.showOptions = this.dataToLateralMenu.data.showOptions;
          }

          if (!this.dataToLateralMenu.data?.showOptions) {
            this.showButtonCreate = true;
          }
          break;

        case PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT:
          this.itemList = [];
          this.showCardsContainer = false;
          this.loadingData = false;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT:
          this.showContextualSearch = false;
          this.showOptions = false;
          this.panel = this.isMobile
            ? CLASSES.PANEL.MOBILE_INACTIVE
            : CLASSES.PANEL.DESKTOP_INACTIVE;
          this.inner = this.isMobile
            ? CLASSES.CONTENT.MOBILE_INACTIVE
            : CLASSES.CONTENT.DESKTOP_INACTIVE;
          this.isActive = false;
          this.overlay = CLASSES.OVERLAY.ACTIVE;
          this.icons.forEach(icon => {
            icon.class = CLASSES.ITEM.INACTIVE;
          });
          this.itemList = [];
          this.selectedItem = "";
          break;

        case PANEL_INFO_CONSTANTS.ACTION.UPDATE_MODAL:
          this.modal = this.dataToLateralMenu.data;
          break;

        case PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL:
          this.setModalContext(this.dataToLateralMenu.data);
          break;

        case PANEL_INFO_CONSTANTS.ACTION.MODAL_CAN_NOT_DELETE:
          this.showModalValidDelete();
          break;

        case PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL:
          this.showModalCancel(this.dataToLateralMenu.data);
          break;

        case PANEL_INFO_CONSTANTS.ACTION.MODAL_DELETE:
          this.showModalDelete(this.dataToLateralMenu.data);
          break;

        case PANEL_INFO_CONSTANTS.ACTION.MODAL_SAVE:
          this.showModalSave(this.dataToLateralMenu.data);
          break;

        case PANEL_INFO_CONSTANTS.ACTION.OPEN_LATERAL_PANEL:
          this.unCollapse(this.dataToLateralMenu.data);
          break;

        case PANEL_INFO_CONSTANTS.ACTION.COMPLETE:
          this.showModalComplete(this.dataToLateralMenu.data);
          break;
      }
    }
  }

  unCollapse(key: string) {
    const index = this.icons.findIndex(icon => key == icon.key);
    if (index != -1) {
      this.setActive(index);
    }
  }

  setModalContext(modalContext: SearchContextModal) {
    if (modalContext.callbackHandleOperation) {
      this.callbackHandleOperation = modalContext.callbackHandleOperation;
    }
    this.componentName = modalContext.componentName as string;

    this.sendToMainView({
      from: PANEL_INFO_CONSTANTS.FROM.PANEL,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: PANEL_INFO_CONSTANTS.ACTION.FUNTION_MODAL,
      data: this.handleOperation
    });
  }

  setSearchContext(searchContext: SearchContext) {
    this.showContextualSearch = true;
    this.tittleSearch = searchContext.title;
    this.filterArray = lodash.cloneDeep(searchContext.filterArray);
    this.CLICK_ACTION = searchContext.clickAction;
    this.OPERATIONS = searchContext.operations.filter(
      filter => filter != LIST_DATA_EVENTS.SAVE_DATA
    );
    this.callbackHandleOperation = searchContext.callbackHandleOperation;
    this.componentName = searchContext.componentName as string;
    this.listOptionsToFilter = searchContext.optionsToFilter
      ? searchContext.optionsToFilter
      : [];
    if (searchContext.options) {
      this.options = searchContext.options;
    } else {
      this.options = [];
    }
    this.descriptions = searchContext.descriptions;
    if (
      searchContext.operations.includes(LIST_DATA_EVENTS.SAVE_DATA) &&
      searchContext.textButtonCreate
    ) {
      this.textButtonCreate = searchContext.textButtonCreate;
    }
    this.showButtonCreate = this.textButtonCreate != "";
  }

  setListItemContext(itemListResult: Array<FormStatus | HeaderInfoGroup>) {
    this.itemList = itemListResult;
  }

  async onBottomContext() {
    this.loadingData = true;
    await this.sendToMainView({
      from: PANEL_INFO_CONSTANTS.FROM.PANEL,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT
    });
  }

  emitSearchEvent(querySearch: QuerySend) {
    this.loadingData = true;
    console.log("emitSearchEvent", querySearch);
    this.sendToMainView({
      from: PANEL_INFO_CONSTANTS.FROM.PANEL,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE,
      data: querySearch
    });
  }

  showModal(modal: string) {
    this.sendToMainView({
      from: PANEL_INFO_CONSTANTS.FROM.PANEL,
      type: PANEL_INFO_CONSTANTS.TYPE.OPTIONS,
      action: modal
    });
  }

  canShow(can: string) {
    if (!can) {
      return true;
    }
    return this.views.includes(can) ? true : false;
  }

  showModalInternal(
    formMessage: ModalFormData,
    component: string,
    nameComponent = ""
  ) {
    this.modal = {
      id: formMessage.ID,
      actived: true,
      title: formMessage.TITLE,
      text: formMessage.TEXT.replace(
        FORM_MESSAGES.COMPONENT,
        `${component}`
      ).replace(FORM_MESSAGES.NAME_COMPONENT, `${nameComponent}`),
      textAccept: formMessage.TEXT_ACCEPT
    };
  }

  showModalCancel(modalContext: SearchContextModal | null) {
    const nameComponent: string = modalContext
      ? modalContext.componentName ?? ""
      : this.componentName;
    const nameItem: string = modalContext ? modalContext.itemName ?? "" : "";
    this.actionData.operation = LIST_DATA_EVENTS.CANCEL_DATA;
    this.callbackHandleOperationTemp = modalContext?.callbackHandleOperation;
    this.showModalInternal(
      FORM_MESSAGES.CANCEL_MODAL,
      nameComponent ?? this.componentName,
      nameItem
    );
  }
  showModalDelete(modalContext: SearchContextModal | null) {
    const nameComponent: string = modalContext
      ? modalContext.componentName ?? ""
      : this.componentName;
    const nameItem: string = modalContext ? modalContext.itemName ?? "" : "";
    this.actionData.operation = LIST_DATA_EVENTS.DELETE_DATA;
    this.callbackHandleOperationTemp = modalContext?.callbackHandleOperation;
    this.showModalInternal(
      FORM_MESSAGES.DELETE_MODAL,
      nameComponent ?? this.componentName,
      nameItem
    );
  }
  showModalSave(modalContext: SearchContextModal | null) {
    const nameComponent: string = modalContext
      ? modalContext.componentName ?? ""
      : this.componentName;
    const nameItem: string = modalContext ? modalContext.itemName ?? "" : "";
    this.actionData.operation = LIST_DATA_EVENTS.SAVE_DATA;
    this.showModalInternal(
      FORM_MESSAGES.SAVE_MODAL,
      nameComponent ?? this.componentName,
      nameItem
    );
  }

  showModalComplete(modalContext: SearchContextModal | null) {
    const nameComponent: string = modalContext
      ? modalContext.componentName ?? ""
      : this.componentName;
    const nameItem: string = modalContext ? modalContext.itemName ?? "" : "";
    this.actionData.operation = LIST_DATA_EVENTS.COMPLETE_APPOINTMENT;
    this.callbackHandleOperationTemp = modalContext?.callbackHandleOperation;
    this.showModalInternal(
      FORM_MESSAGES.SAVE_MODAL,
      nameComponent ?? this.componentName,
      nameItem
    );
  }

  showModalValidDelete() {
    this.actionData.operation = LIST_DATA_EVENTS.DELETE_VALID_DATA;
    this.showModalInternal(FORM_MESSAGES.DESACTIVED_MODAL, this.componentName);
  }

  handleOperation(
    operation: string,
    id: string,
    state: string | boolean,
    documentName = ""
  ) {
    this.actionData = { operation, id, state, documentName };
    switch (operation) {
      case LIST_DATA_EVENTS.DELETE_DATA:
        if (this.componentName) {
          this.showModalInternal(
            FORM_MESSAGES.DELETE_MODAL,
            this.componentName,
            documentName
          );
          return;
        }
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        if (this.componentName) {
          this.showModalInternal(
            FORM_MESSAGES.ACTIVED_MODAL,
            this.componentName,
            documentName
          );
          return;
        }
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        if (this.componentName) {
          this.showModalInternal(
            FORM_MESSAGES.DESACTIVED_MODAL,
            this.componentName,
            documentName
          );
          return;
        }
        break;
      case LIST_DATA_EVENTS.EDIT_DATA:
        if (
          this.componentName &&
          this.selectedItem &&
          this.selectedItem != this.actionData.id
        ) {
          this.showModalInternal(
            FORM_MESSAGES.CHANGE_MODAL,
            this.componentName,
            documentName
          );
          return;
        }
        break;
      case LIST_DATA_EVENTS.DUPLICATE_DATA:
        if (this.componentName) {
          this.showModalInternal(
            FORM_MESSAGES.DUPLICATE_RULE,
            this.componentName,
            documentName
          );
          return;
        }
        break;
    }
    this.callbackHandleOperation(operation, id, state, documentName);
  }

  handleModalAccept() {
    this.modal.actived = false;
    if (this.callbackHandleOperationTemp) {
      this.callbackHandleOperationTemp(
        this.actionData.operation,
        this.actionData.id,
        this.actionData.state
      );
      this.callbackHandleOperationTemp = undefined;
    } else {
      this.callbackHandleOperation(
        this.actionData.operation,
        this.actionData.id,
        this.actionData.state
      );
    }
  }

  handleModalCancel() {
    this.modal.actived = false;
  }

  async showCrudSave() {
    this.sendToMainView({
      from: PANEL_INFO_CONSTANTS.FROM.PANEL,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE
    });
  }

  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    if (target.scrollTop + target.clientHeight + 5 >= target.scrollHeight) {
      this.onBottomContext();
      target.scrollTop -= 3;
    }
    this.showGoTopBtn = target.scrollTop >= 100;
  }

  goToTop() {
    const target = document.getElementById(this.LIST_ID);
    if (target) {
      target.scrollTop = 0;
      this.showGoTopBtn = false;
    }
  }

  serviceUpdated() {
    this.refreshServices = !this.refreshServices;
  }
}
